Ext.define('SA.VectorMapExportTextLabel', {
    singleton: true,

    getSvg({backgroundColor, fontColor, fontFamily, fontSize, isBold, isItalic, isUnderline, text}) {
        return SA.Svg.wrap({
            backgroundColor: backgroundColor ? `#${backgroundColor}` : 'transparent',

            content: {
                type: 'text',
                content: text,
                dominantBaseline: 'hanging',
                fill: `#${fontColor}`,

                style: {
                    fontFamily,
                    fontSize: `${fontSize}px`,
                    fontStyle: isItalic ? 'italic' : 'normal',
                    fontWeight: isBold ? 'bold' : 'normal',
                    textDecorationLine: isUnderline ? 'underline' : 'none'
                }
            }
        });
    }
});